import {
  Navbar,
  Container,
  Nav,
  Offcanvas,
  Badge,
  OverlayTrigger,
  Tooltip,
  Accordion,
  Dropdown,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NavDropdown from 'react-bootstrap/NavDropdown';

import { Form } from "react-bootstrap";
import {
  faBagShopping,
  faDollarSign,
  faHeart,
  faMagnifyingGlass,
  faMoneyBill,
  faUser,
  faWallet,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import Green_btn from "../common-components/common_btn/green_btn/Green_btn";
import { useEffect, useRef, useState } from "react";
import Login_Modal from "../common-components/common_modal/login_modal/Login_Modal";
import Reset_Password_Modal from "../common-components/common_modal/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../common-components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Success_Modal from "../common-components/common_modal/success_modal/Success_Modal";
import Cancel_Reason_Modal from "../common-components/common_modal/cancel_reason_modal/Cancel_Reason_Modal";
import OrderTrackModal from "../common-components/common_modal/order_track_modal/OrderTrackModal";
import { useDispatch, useSelector } from "react-redux";
import { myAccount } from "../../features/my_account/Slice";
import Cookies from "js-cookie";
import { getAllCart, postToLoginCart } from "../../features/cart/cartSlice";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import ListGroup from "react-bootstrap/ListGroup";
import {
  allCurrency,
  appSetup,
  ExchangeRate,
  getAllChildCategory,
  getAllSubCategory,
  setCurrentCurrency,
} from "../../features/master/masterSlice";

function Header() {
  const location = useLocation();

  // Reusable Tooltip Renderer with dynamic label
  const renderTooltip = (label) => (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {label}
    </Tooltip>
  );
  const [showSearch, setShowSearch] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const currentPath = location.pathname;
  const searchRef = useRef(null); // ✅ Ref for detecting outside click

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const dispatch = useDispatch();
  const user = useSelector((state) => state.myaccount.addMyaccount);

  // useEffect(() => {
  //   dispatch(myAccount());
  // }, [dispatch]);
  const isSignin = useSelector((state) => state.auth.is_signin);
  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const currency = useSelector((state) => state.master.all_currency);
  useEffect(() => {
    dispatch(allCurrency());
  }, [dispatch]);





  useEffect(() => {
    if (currency.length && !currentCurrency) {
      dispatch(setCurrentCurrency(currency[0]));
    }
  }, [currency, currentCurrency, dispatch]);

  const allcartData = useSelector((state) => state.cart.allCarts);
  useEffect(() => {
    dispatch(getAllCart(isSignin));
  }, [dispatch]);

  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  // useEffect(() => {
  //   dispatch(getAllWishlist());
  // }, [dispatch]);

  useEffect(() => {
    const loginCart = async () => {
      if (isSignin) {
        const res = await dispatch(postToLoginCart());
        if (res.meta?.requestStatus === "fulfilled") {
        } else if (res.meta?.requestStatus === "rejected") {
          console.log("Error:", res.payload || "Login Cart Post Failed");
        }
      }
      await dispatch(getAllCart(isSignin));
    };

    loginCart();
  }, [dispatch, isSignin]);
  const [email, setEmail] = useState();
  const [contact, setContact] = useState();

  const [searchQuery, setSearchQuery] = useState("");
  const products = ["One", "Two", "Three", "Four", "Five"]; // Example product list

  const filteredItems = products.filter((item) =>
    item.toLowerCase().includes(searchQuery.toLowerCase()),
  );
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState();
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && searchTerm.trim() !== "") {
      navigate(`/shops?search=${encodeURIComponent(searchTerm)}`);
      // dispatch(PostSearchHistory({ name: searchTerm }));
    }
  };

  const handleSearchClick = async () => {
    if (searchTerm.trim() !== "") {
      navigate(`/shops?search=${encodeURIComponent(searchTerm)}`);
      // await dispatch(PostSearchHistory({ name: searchTerm }));
    }
  };

  // ✅ Detect click outside and hide search bar
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSearch(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const app_setup = useSelector((state) => state.master.app_setup);

  // useEffect(() => {
  //   dispatch(appSetup());
  // }, [dispatch]);

  const [showCategory, setShowCategory] = useState(false);

  const [openMega, setOpenMega] = useState(false);
  const [openMegaJewlery, setOpenMegaJewlery] = useState(false);
  const [openMain, setOpenMain] = useState(null);
  const [openSub, setOpenSub] = useState(null);

  const category = useSelector((state) => state.master.categories);
  const subcategories = useSelector((state) => state.master.subcategories);
  const childcategories = useSelector((state) => state.master.childcategories);

  useEffect(() => {
    const handleClickOutside = () => {
      setOpenMega(false);
      setShowCategory(false);
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const engagementMenu = [
    {
      title: "Diamond Rings",
      items: [
        "Round Cut Solitaire",
        "Princess Cut Halo Ring",
        "Cushion Cut Three-Stone",
        "Marquise Vintage Ring",
        "Emerald Side-Stone Ring",
        "Pear Cluster Engagement Ring",
      ],
    },
    {
      title: "Gemstone Rings",
      items: [
        "Blue Sapphire Engagement Ring",
        "Ruby Oval Cut Ring",
        "Emerald Cushion Cut Ring",
        "Morganite Rose Gold Ring",
        "Tanzanite Halo Design Ring",
      ],
    },
    {
      title: "Gold Engagement Rings",
      items: [
        "Yellow Gold Solitaire",
        "Rose Gold Halo Ring",
        "White Gold Princess Cut",
        "Two-Tone Twisted Band",
      ],
    },
    {
      title: "Platinum Engagement Rings",
      items: [
        "Platinum Round Cut Solitaire",
        "Platinum Halo Cushion Ring",
        "Platinum Vintage Filigree",
        "Platinum Modern Minimalist",
      ],
    },
    {
      title: "Lab-Grown Diamond Rings",
      items: [
        "Lab Grown Round Solitaire",
        "Lab Cushion Halo",
        "Lab Oval Vintage Ring",
        "Lab Emerald Three-Stone",
      ],
    },
    {
      title: "Couple Rings",
      items: [
        "Matching Couple Bands",
        "His & Her Diamond Bands",
        "Custom Engraved Couple Rings",
      ],
    },
  ];

  const engagementAccordionData = engagementMenu.map((cat, catIndex) => ({
    name: cat.title,
    sub_categories: cat.items.map((item, itemIndex) => ({
      id: `${catIndex}-${itemIndex}`, // unique for Link
      name: item,
    })),
  }));

  useEffect(() => {
    const closeMenu = () => setActiveMenu(null);
    document.addEventListener("click", closeMenu);
    return () => document.removeEventListener("click", closeMenu);
  }, []);

  const handleLinkClick = () => { };

  const finalMenu = category.map((cat) => ({
    id: cat.id,
    name: cat.name,
    sub_categories: subcategories
      .filter((sub) => sub.p_category_id === cat.id)
      .map((sub) => ({
        id: sub.id,
        name: sub.name,
        img: sub.image,
        children: sub.p_child_categories || [], // <-- correct children
      })),
  }));

  const [activeMenu, setActiveMenu] = useState(null);

  const callSubCategories = async (cat_id) => {
    await dispatch(getAllSubCategory({ category_id: cat_id }));
  };

  console.log("finalMenu", finalMenu);

  const handleNavigate = (path) => {
    navigate(path);
    setOpenMega(false); // <-- CLOSE ON CLICK
  };

  const MegaMenu = ({ data, activeMenu, setActiveMenu }) => {
    const isOpen = activeMenu === data.id;

    return (
      <div
        className="mega_menu_main"
        // onMouseEnter={() => setOpen(true)}
        // onMouseLeave={() => setOpen(false)}
        onClick={(e) => {
          e.stopPropagation();
          callSubCategories(data.id);
          setActiveMenu(data.id); // <-- open only this menu
        }}
      >
        <Nav.Link className="categories_btn">{data.name}</Nav.Link>

        {isOpen && (
          <div className="mega_dropdown">
            {/* <div className="row">
              <div className="col-12"> */}
            <div className="mega_right_panel">
              <div className="all_divs_holder">
                {data.sub_categories.map((sub) => (
                  <div
                    // className="col-4"
                    key={sub.id}
                  >
                    <div className="mega_col">
                      <h5>{sub.name}</h5>

                      {sub?.children.map((child) => (
                        <p
                          key={child.id}
                          // onClick={(e) => {
                          //   e.stopPropagation();
                          //   setActiveMenu(null);
                          //   navigate(`/categories`);
                          // }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveMenu(null);
                            handleNavigate(
                              `/product-listing-child-category/${child?.id
                              }?sub_category_id=${sub?.id
                              }&category_name=${encodeURIComponent(
                                data?.name,
                              )}&subcategory_name=${encodeURIComponent(
                                sub?.name,
                              )}&category_image=${encodeURIComponent(
                                sub?.img,
                              )}`,
                            );
                          }}
                        >
                          {child.name}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* </div>
            </div> */}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <header className="Header">
        <Navbar expand="lg" className="">
          <Container>
            <div className="header_section_holder">
              {/* Mobile Toggle (only visible below lg) */}
              <Navbar.Toggle
                aria-controls="offcanvasNavbar"
                className="d-lg-none me-3 "
                onClick={handleShow}
              />

              {/* Offcanvas for mobile only */}
              <Navbar.Offcanvas
                show={showOffcanvas}
                onHide={handleClose}
                id="offcanvasNavbar"
                aria-labelledby="offcanvasNavbarLabel"
                placement="start"
                className="d-lg-none mobile_view_header_offcanvas"
              >
                <Offcanvas.Header closeButton>
                  <div className="logo_holder">
                    <img
                      src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                      className="offcanvaslogo_img"
                    />
                  </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="main-nav flex-column">
                    <Nav.Link
                      as={Link}
                      to="/"
                      className={currentPath === "/" ? "active" : ""}
                      onClick={handleClose}
                    >
                      Home
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to="/categories"
                      className={currentPath === "/categories" ? "active" : ""}
                      onClick={handleClose}
                    >
                      Products
                    </Nav.Link>

                    <Nav.Link
                      as={Link}
                      to="/about-us"
                      className={currentPath === "/about-us" ? "active" : ""}
                      onClick={handleClose}
                    >
                      About US
                    </Nav.Link>



                    {/* <Accordion>
                      {finalMenu.map((cat, catIndex) => (
                        <Accordion.Item eventKey={`cat-${catIndex}`} key={cat.id}>
                          <Accordion.Header
                            onClick={() => {
                              callSubCategories(cat.id);
                            }}
                          >
                            {cat.name}
                          </Accordion.Header>

                          <Accordion.Body>
                            <Accordion>
                              {cat?.sub_categories.map((sub, subIndex) => (
                                <Accordion.Item
                                  eventKey={`sub-${catIndex}-${subIndex}`}
                                  key={sub.id}
                                  className="inner_accordion"
                                >
                                  <Accordion.Header>{sub.name}</Accordion.Header>

                                  <Accordion.Body>
                                    <div className="secondMobiledrop mb-0">
                                      {sub?.children.map((child) => (
                                        <div
                                          className="subaccmenu"
                                          key={child.id}
                                        >
                                          <Link
                                            to={`/product-listing-child-category/${child?.id
                                              }?sub_category_id=${sub?.id
                                              }&category_name=${encodeURIComponent(
                                                cat?.name,
                                              )}&subcategory_name=${encodeURIComponent(
                                                sub?.name,
                                              )}&category_image=${encodeURIComponent(
                                                sub?.img,
                                              )}`}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleClose();
                                            }}
                                          >
                                            {child.name}
                                          </Link>
                                        </div>
                                      ))}
                                    </div>
                                  </Accordion.Body>
                                </Accordion.Item>
                              ))}
                            </Accordion>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}
                    </Accordion> */}



                    {/* <Nav.Link
                      as={Link}
                      to="/enggagement"
                      className={currentPath === "/enggagement" ? "active" : ""}
                      onClick={handleClose}
                    >
                      Engagement
                    </Nav.Link> */}

                    <Nav.Link
                      as={Link}
                      to="/contact"
                      className={currentPath === "/contact" ? "active" : ""}
                      onClick={handleClose}
                    >
                      Contact Us
                    </Nav.Link>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>

              <div className="header-icons mobile_view">
                <div
                  className="icon-link"
                  onClick={() => setShowSearch(!showSearch)}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </div>
                </div>
              </div>

              <div className="desktop_view_logo">
                {/* Logo */}
                <Navbar.Brand as={Link} to="/" className="brand-logo">
                  <div className="logo_holder">
                    <img
                      // src="/assets/images/logo/new_ekansi_logo.png"
                      src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                      className="logo_img"
                    />
                  </div>
                </Navbar.Brand>
              </div>
            </div>

            {/* Desktop Navigation (visible lg and up) */}
            <div className="d-none d-lg-flex align-items-center justify-content-center w-100">
              <Nav className="main-nav ">
                <Nav.Link
                  as={Link}
                  to="/"
                  className={currentPath === "/" ? "active" : ""}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/categories"
                  className={currentPath === "/categories" ? "active" : ""}
                >
                  Category
                </Nav.Link>


                <Nav.Link
                  as={Link}
                  to="/about-us"
                  className={currentPath === "/about-us" ? "active" : ""}
                >
                  About Us
                </Nav.Link>


                {/* {finalMenu.map((cat) => (
                  <MegaMenu
                    key={cat.id}
                    data={cat}
                    activeMenu={activeMenu}
                    setActiveMenu={setActiveMenu}
                  />
                ))} */}


                {/* <NavDropdown title="Category" id="basic-nav-dropdown">
                  {finalMenu.map((cat) => (
                    <NavDropdown.Item href="">
                      <MegaMenu
                        key={cat.id}
                        data={cat}
                        activeMenu={activeMenu}
                        setActiveMenu={setActiveMenu}
                      />
                    </NavDropdown.Item>
                  ))}
                </NavDropdown> */}




                {/* <Nav.Link
                  as={Link}
                  to="/enggagement"
                  className={currentPath === "/enggagement" ? "active" : ""}
                  onClick={handleClose}
                >
                  Engagement
                </Nav.Link> */}

                <Nav.Link
                  as={Link}
                  to="/contact"
                  className={currentPath === "/contact" ? "active" : ""}
                >
                  Contact Us
                </Nav.Link>
              </Nav>
            </div>

            <div className="mobile_view_logo">
              {/* Logo */}
              <Navbar.Brand as={Link} to="/" className="brand-logo">
                <div className="logo_holder">
                  <img
                    // src="/assets/images/logo/new_ekansi_logo.png"
                    src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                    className="logo_img"
                  />
                </div>
              </Navbar.Brand>
            </div>

            <div className="header_section_holder">
              <div className="header-icons ">
                {/* 🔍 Magnifying Glass Icon */}
                <div
                  className="icon-link desktop_view_search"
                  onClick={() => setShowSearch(!showSearch)}
                >
                  <div className="icon_holder">
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </div>
                </div>

                <Link
                  to="/wishlist"
                  className={`icon-link ${currentPath === "/wishlist" ? "active" : ""
                    }`}
                >
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Wishlist")}
                  >
                    <div className="icon_holder">
                      <FontAwesomeIcon icon={faHeart} />
                      <Badge className="badge_holder">
                        {allWishlist?.data?.length || 0}
                      </Badge>
                    </div>
                  </OverlayTrigger>
                </Link>
                <Link
                  to="/product-cart"
                  className={`icon-link ${currentPath === "/product-cart" ? "active" : ""
                    }`}
                >
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Cart")}
                  >
                    <div className="icon_holder">
                      <FontAwesomeIcon icon={faBagShopping} />
                      <Badge className="badge_holder">
                        {allcartData?.data?.length || 0}
                      </Badge>
                    </div>
                  </OverlayTrigger>
                </Link>

                {/* {isSignin && (
                  <Link
                    to="/wallet"
                    className={`icon-link ${currentPath === "/wallet" ? "active" : ""
                      }`}
                  >
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip("Wallet")}
                    >
                      <div className="icon_holder">
                        <FontAwesomeIcon icon={faWallet} />
                      </div>
                    </OverlayTrigger>
                  </Link>
                )} */}

                {isSignin && (
                  <Link
                    to="/account"
                    className={`icon-link ${currentPath === "/account" ? "active" : ""
                      }`}
                  >
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip("My Account")}
                    >
                      <FontAwesomeIcon icon={faUser} />
                    </OverlayTrigger>
                  </Link>
                )}

                {/* <Dropdown align="end">
                  <Dropdown.Toggle
                    as="div"
                    className="icon-link"
                    style={{ cursor: "pointer" }}
                  >
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip("")}
                    >
                      <div className="icon_holder">
                        <FontAwesomeIcon icon={faMoneyBill} />
                      </div>
                    </OverlayTrigger>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {currency.map((currency) => (
                      <Dropdown.Item
                        className="currency_text"
                        key={currency}
                        onClick={() => dispatch(setCurrentCurrency(currency))}
                      >
                        {currency?.country}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown> */}

                {!isSignin && (
                  <div
                    className="icon-link"
                    onClick={() => {
                      setShowLoginModal(true);
                    }}
                  >
                    <div className="icon_holder">
                      <FontAwesomeIcon icon={faUser} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </Navbar>


        <Container ref={searchRef}>
          <div className="row justify-content-center">
            <div className="col-md-6 col-12">
              {showSearch && (
                <div className="headsearch">
                  <div className="searchdiv">
                    <Form.Control
                      placeholder="Search Product"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={handleKeyPress}
                      autoFocus
                    />
                    <button
                      type="submit"
                      className="searchbtn"
                      onClick={handleSearchClick}
                    >
                      <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        className="search_icon"
                      />
                    </button>
                  </div>

                  <div
                    className="close_div"
                    onClick={() => {
                      setShowSearch(!showSearch);
                    }}
                  >
                    <FontAwesomeIcon icon={faXmark} className="close_icon" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </Container>

        {/* <div className="marquu_holder">
          <marquee behavior="scroll" direction="left" scrollamount="10">
            This site is currently under construction.
          </marquee>
        </div> */}



        <Login_Modal
          show={showLoginModal}
          onHide={() => {
            setShowLoginModal(false);
          }}
          setShowResetModal={() => setShowResetModal(true)}
          setShowAccountCreted={() => setShowAccountCreted(true)}
          setShowLogin={() => setShowLogin(true)}
        />

        <Reset_Password_Modal
          email={email}
          setEmail={setEmail}
          contact={contact}
          setContact={setContact}
          show={showResetModal}
          onHide={() => {
            setShowResetModal(false);
          }}
          setShowSetPassModal={() => setShowSetPassModal(true)}
        />

        <Set_New_Password_Modal
          email={email}
          setEmail={setEmail}
          contact={contact}
          setContact={setContact}
          show={showSetPassModal}
          onHide={() => {
            setShowSetPassModal(false);
          }}
          setShowSucsessModal={() => setShowSucsessModal(true)}
        />

        <Success_Modal
          show={showSuccessModal}
          onHide={() => {
            setShowSucsessModal(false);
          }}
          successText="Password Reseted Successfully!"
        />

        <Success_Modal
          show={showAccountCreted}
          onHide={() => {
            setShowAccountCreted(false);
          }}
          successText="Account Created Successful!"
        />

        <Success_Modal
          show={showLogin}
          onHide={() => {
            setShowLogin(false);
          }}
          successText="Login Successfully!"
        />
      </header>


    </>
  );
}

export default Header;
